import React, { useEffect, createElement } from 'react';
import { LaunchBanner } from '../components/landing/LaunchBanner';
import { HeroSection } from '../components/landing/HeroSection';
import { PremiumShowcaseSection } from '../components/landing/PremiumShowcaseSection';
import { ProblemSection } from '../components/landing/ProblemSection';
import { HowItWorksSection } from '../components/landing/HowItWorksSection';
import { TestimonialsSection } from '../components/landing/TestimonialsSection';
import { ExpertSection } from '../components/landing/ExpertSection';
import { PricingSection } from '../components/landing/PricingSection';
import { GuaranteeSection } from '../components/landing/GuaranteeSection';
import { FAQSection } from '../components/landing/FAQSection';
import { FinalCTASection } from '../components/landing/FinalCTASection';
import { Footer } from '../components/landing/Footer';
export function LandingPage() {
  useEffect(() => {
    // Primary SEO Meta Tags
    document.title = 'Plan Anti-Pantallas Express | 30 Actividades Sin Pantallas para Niños - $9.95';
    // Meta Description (optimized for all search engines)
    const setOrUpdateMeta = (name: string, content: string, isProperty = false) => {
      const attribute = isProperty ? 'property' : 'name';
      let meta = document.querySelector(`meta[${attribute}="${name}"]`);
      if (meta) {
        meta.setAttribute('content', content);
      } else {
        meta = document.createElement('meta');
        meta.setAttribute(attribute, name);
        meta.setAttribute('content', content);
        document.head.appendChild(meta);
      }
    };
    // Standard Meta Tags
    setOrUpdateMeta('description', '✅ 7 Ebooks Premium con 30+ actividades sin pantallas para niños. Sistema completo para reducir el tiempo de pantalla. Descarga inmediata PDF. Garantía 30 días. Oferta de lanzamiento: $9.95 (valor $347)');
    setOrUpdateMeta('keywords', 'actividades sin pantallas para niños, plan anti-pantallas, reducir tiempo de pantalla niños, actividades infantiles sin tecnología, ebook actividades niños, crianza digital consciente, tiempo en familia sin pantallas, actividades educativas niños, entretenimiento infantil sin pantallas, guía padres pantallas');
    setOrUpdateMeta('author', 'Plan Anti-Pantallas');
    setOrUpdateMeta('robots', 'index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1');
    setOrUpdateMeta('googlebot', 'index, follow');
    setOrUpdateMeta('bingbot', 'index, follow');
    setOrUpdateMeta('language', 'Spanish');
    setOrUpdateMeta('revisit-after', '7 days');
    // Open Graph Tags (Facebook, LinkedIn, Pinterest)
    setOrUpdateMeta('og:title', 'Plan Anti-Pantallas Express | 30 Actividades Sin Pantallas para Niños', true);
    setOrUpdateMeta('og:description', '7 Ebooks Premium con actividades sin pantallas. Sistema completo para familias. Descarga inmediata. Solo $9.95', true);
    setOrUpdateMeta('og:type', 'website', true);
    setOrUpdateMeta('og:url', window.location.href, true);
    setOrUpdateMeta('og:site_name', 'Plan Anti-Pantallas', true);
    setOrUpdateMeta('og:locale', 'es_ES', true);
    setOrUpdateMeta('og:locale:alternate', 'es_MX', true);
    setOrUpdateMeta('og:locale:alternate', 'es_AR', true);
    setOrUpdateMeta('og:image', 'https://cdn.magicpatterns.com/uploads/aa1PP3jtKEi1XUgN9Xr2WR/portada_plan_antipantalla.png', true);
    setOrUpdateMeta('og:image:width', '1200', true);
    setOrUpdateMeta('og:image:height', '630', true);
    setOrUpdateMeta('og:image:alt', 'Plan Anti-Pantallas Express - 7 Ebooks Premium', true);
    // Twitter Card Tags
    setOrUpdateMeta('twitter:card', 'summary_large_image');
    setOrUpdateMeta('twitter:title', 'Plan Anti-Pantallas Express | 30 Actividades Sin Pantallas');
    setOrUpdateMeta('twitter:description', '7 Ebooks Premium con actividades sin pantallas para niños. Sistema completo. Solo $9.95');
    setOrUpdateMeta('twitter:image', 'https://cdn.magicpatterns.com/uploads/aa1PP3jtKEi1XUgN9Xr2WR/portada_plan_antipantalla.png');
    setOrUpdateMeta('twitter:image:alt', 'Plan Anti-Pantallas Express - 7 Ebooks Premium');
    // Mobile Optimization
    const viewport = document.querySelector('meta[name="viewport"]');
    if (viewport) {
      viewport.setAttribute('content', 'width=device-width, initial-scale=1.0, maximum-scale=5.0, user-scalable=yes, viewport-fit=cover');
    }
    // Theme Color (for mobile browsers)
    setOrUpdateMeta('theme-color', '#1e3a8a');
    setOrUpdateMeta('msapplication-TileColor', '#1e3a8a');
    // Language and Region
    document.documentElement.lang = 'es';
    document.documentElement.setAttribute('dir', 'ltr');
    // Canonical URL (prevent duplicate content)
    let canonical = document.querySelector('link[rel="canonical"]');
    if (!canonical) {
      canonical = document.createElement('link');
      canonical.setAttribute('rel', 'canonical');
      canonical.setAttribute('href', window.location.href.split('?')[0]);
      document.head.appendChild(canonical);
    }
    // Structured Data (Schema.org) for Google, Bing, Yandex
    const structuredData = {
      '@context': 'https://schema.org',
      '@type': 'Product',
      name: 'Plan Anti-Pantallas Express - Pack Premium',
      description: '7 Ebooks digitales premium con más de 30 actividades sin pantallas para niños. Sistema completo para reducir el tiempo de pantalla en familia.',
      image: ['https://cdn.magicpatterns.com/uploads/aa1PP3jtKEi1XUgN9Xr2WR/portada_plan_antipantalla.png', 'https://cdn.magicpatterns.com/uploads/nUvrWXq4qXNGHi5fgtVoVg/bono_1_cover_1.png', 'https://cdn.magicpatterns.com/uploads/kzNL9jxip1zWycrvFHDPYB/bono_2_cover_1.png'],
      brand: {
        '@type': 'Brand',
        name: 'Plan Anti-Pantallas'
      },
      offers: {
        '@type': 'Offer',
        url: 'https://mikioscodigital.com/checkout?variant=51784383398169&quantity=1',
        priceCurrency: 'USD',
        price: '9.95',
        priceValidUntil: '2025-12-31',
        availability: 'https://schema.org/InStock',
        itemCondition: 'https://schema.org/NewCondition',
        seller: {
          '@type': 'Organization',
          name: 'Plan Anti-Pantallas'
        }
      },
      aggregateRating: {
        '@type': 'AggregateRating',
        ratingValue: '4.9',
        reviewCount: '127',
        bestRating: '5',
        worstRating: '1'
      },
      review: [{
        '@type': 'Review',
        reviewRating: {
          '@type': 'Rating',
          ratingValue: '5',
          bestRating: '5'
        },
        author: {
          '@type': 'Person',
          name: 'María González'
        },
        reviewBody: 'Mis tardes ya no son un caos. Mi hijo de 5 años ahora me pide hacer las actividades en lugar de ver YouTube.'
      }],
      category: 'Libros Digitales / Educación Infantil',
      sku: '51784383398169',
      gtin: '51784383398169'
    };
    // Organization Schema
    const organizationSchema = {
      '@context': 'https://schema.org',
      '@type': 'Organization',
      name: 'Plan Anti-Pantallas',
      url: window.location.origin,
      logo: 'https://cdn.magicpatterns.com/uploads/aa1PP3jtKEi1XUgN9Xr2WR/portada_plan_antipantalla.png',
      contactPoint: {
        '@type': 'ContactPoint',
        email: 'contactomikioscodigital@gmail.com',
        contactType: 'Customer Service',
        availableLanguage: ['Spanish', 'es']
      },
      sameAs: ['https://www.instagram.com/kiosscodigital/', 'https://www.facebook.com/contactokd', 'https://www.youtube.com/@mikioscodigital']
    };
    // WebSite Schema (for search box)
    const websiteSchema = {
      '@context': 'https://schema.org',
      '@type': 'WebSite',
      name: 'Plan Anti-Pantallas',
      url: window.location.origin,
      potentialAction: {
        '@type': 'SearchAction',
        target: {
          '@type': 'EntryPoint',
          urlTemplate: `${window.location.origin}/search?q={search_term_string}`
        },
        'query-input': 'required name=search_term_string'
      }
    };
    // Insert or update structured data
    let structuredDataScript = document.querySelector('script[type="application/ld+json"]');
    if (!structuredDataScript) {
      structuredDataScript = document.createElement('script');
      structuredDataScript.setAttribute('type', 'application/ld+json');
      document.head.appendChild(structuredDataScript);
    }
    structuredDataScript.textContent = JSON.stringify([structuredData, organizationSchema, websiteSchema]);
    // Preconnect to external domains (performance optimization)
    const preconnectDomains = ['https://cdn.magicpatterns.com', 'https://mikioscodigital.com', 'https://fonts.googleapis.com', 'https://fonts.gstatic.com'];
    preconnectDomains.forEach(domain => {
      let link = document.querySelector(`link[rel="preconnect"][href="${domain}"]`);
      if (!link) {
        link = document.createElement('link');
        link.setAttribute('rel', 'preconnect');
        link.setAttribute('href', domain);
        link.setAttribute('crossorigin', 'anonymous');
        document.head.appendChild(link);
      }
    });
    // Alternate language versions (hreflang for international SEO)
    const hreflangs = [{
      lang: 'es',
      href: window.location.href
    }, {
      lang: 'es-ES',
      href: window.location.href
    }, {
      lang: 'es-MX',
      href: window.location.href
    }, {
      lang: 'es-AR',
      href: window.location.href
    }, {
      lang: 'x-default',
      href: window.location.href
    }];
    hreflangs.forEach(({
      lang,
      href
    }) => {
      let link = document.querySelector(`link[rel="alternate"][hreflang="${lang}"]`);
      if (!link) {
        link = document.createElement('link');
        link.setAttribute('rel', 'alternate');
        link.setAttribute('hreflang', lang);
        link.setAttribute('href', href);
        document.head.appendChild(link);
      }
    });
  }, []);
  return <div className="min-h-screen bg-brand-cream font-sans text-slate-900 selection:bg-brand-terracotta/20" data-id="element-680">
      {/* Skip to main content (accessibility) */}
      <a href="#main-content" className="sr-only focus:not-sr-only focus:absolute focus:top-4 focus:left-4 focus:z-50 focus:px-4 focus:py-2 focus:bg-brand-navy focus:text-white focus:rounded-lg" data-id="element-681">
        Saltar al contenido principal
      </a>

      <LaunchBanner data-id="element-682" />

      <main id="main-content" role="main" aria-label="Contenido principal" data-id="element-683">
        <HeroSection data-id="element-684" />
        <PremiumShowcaseSection data-id="element-685" />
        <ProblemSection data-id="element-686" />
        <HowItWorksSection data-id="element-687" />
        <TestimonialsSection data-id="element-688" />
        <ExpertSection data-id="element-689" />
        <PricingSection data-id="element-690" />
        <GuaranteeSection data-id="element-691" />
        <FAQSection data-id="element-692" />
        <FinalCTASection data-id="element-693" />
      </main>

      <Footer data-id="element-694" />
    </div>;
}